import { SceneEditTool } from '@/components/SceneEditTool';

const SceneEditPage = () => {
  return <SceneEditTool />;
};

export default SceneEditPage;
